var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 =
    _vm.indicatorMode === "line"
      ? _vm.$u.addUnit(_vm.lineWidth * _vm.length)
      : null
  var s0 =
    _vm.indicatorMode === "line" ? _vm.__get_style([_vm.lineStyle]) : null
  var l0 =
    _vm.indicatorMode === "dot"
      ? _vm.__map(_vm.length, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var s1 = _vm.__get_style([_vm.dotStyle(index)])
          return {
            $orig: $orig,
            s1: s1,
          }
        })
      : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        s0: s0,
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }